import React, { useState, Fragment, useEffect } from "react";
import { Badge, Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumb from "../../components/Common/Breadcrumb";
import "./custom-select.scss";

import ViewData from "./officer/ViewData";
import ViewCommander from "./commander/ViewCommander";

import { GetCookieData, GetCookieToken } from "../Cookie/GetCookie";

import AssignCommander from "./assign/ViewAssign";
import FadeIn from "react-fade-in/lib/FadeIn";
import LoadingPage from "../TESTPage/LoadingPage";
import TimeCommander from "./TimeEntryExit/setTimeEntryExit";
import TimeEntryExitGroup from "./TimeEntryExit/EntryExitOrg";
import axios from "axios";
import { FetchAxiosPost, FetchAxiosPut } from "../../api/axios";
import UploadSlipMoney from "../Financial/UploadSlipMoney";
import LeaveConfig from "../LeaveConfig/index";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Toolbar, Tooltip } from "@mui/material";
import ConfirmModal from "../../components/Common/ConfirmModal";
import ViewDataUser from "./officer/ViewDataUser";
import UserpositionNoDatatable from "./positionNO/userpositionNoDatatable";
import { CheckPosition } from "../Function/CheckPosition";
import { CheckSubAdmin } from "../Function/CheckSubAdmin";

const API_URL = process.env.REACT_APP_API_CORS;

function SetData() {
  const [buttonSection, setButtonSection] = useState(0);
  const [loading, setLoading] = useState(false);
  const user = GetCookieData("userData");
  const filterSubAdmin = user.positionSubAdmin.map(i => i.type_sub_admin);
  const token = GetCookieToken("userToken");
  const location = useLocation();
  const params = new URLSearchParams(location?.search);
  const paramName = params?.get("menu");
  const navigate = useNavigate();
  const [isButtonOn, setIsButtonOn] = useState(null);
  const [onOff, setOnOff] = useState([]);
  const [userInfo, setUserInfo] = useState([]);
  const [onOffID, setOnOffID] = useState(null);
  const [showTextID1, setShowTextID1] = useState(false);
  const [confirmModal, setconfirmModal] = useState(false)

  document.title = "กำหนดข้อมูล | Flexible-Time";

  const toggleButton = () => {
    setIsButtonOn(() => !isButtonOn);
  };

  useEffect(() => {
    if (buttonSection === 0) {
      setShowTextID1(true);
    }
  }, []);

  useEffect(() => {
    const apiGPSurl = `/api/gpsSetting/${onOffID}`;
    if (isButtonOn === true) {
      onOff.map((gps) => {
        let dataOn = {
          latitude: gps.latitude,
          longitude: gps.longitude,
          distance: gps.distance,
          status: gps.status,
          setting: "on",
        };
        FetchAxiosPut(apiGPSurl, dataOn, token);
      });
    }
    if (isButtonOn === false) {
      onOff.map((gps) => {
        let dataOff = {
          latitude: gps.latitude,
          longitude: gps.longitude,
          distance: gps.distance,
          status: gps.status,
          setting: "off",
        };
        FetchAxiosPut(apiGPSurl, dataOff, token);
      });
    }
  }, [isButtonOn]);

  const fetchGPS = async () => {
    const url = `${API_URL}/api/gpsSetting/datatable`;
    const params = new URLSearchParams({
      page: 1,
      size: 10,
      "order[0]": "id",
      "order[1]": "ASC",

    });
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    };
    await axios
      .get(url, config)
      .then((response) => {
        setOnOff(response.data.result);
        setOnOffID(response.data.result.map((i) => i.id));
        const filterSetting = response.data.result.map((i) => i.setting);
        if (filterSetting.toString() === "on") {
          setIsButtonOn(true);
        }
        if (filterSetting.toString() === "off") {
          setIsButtonOn(false);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  useEffect(() => {
    fetchGPS();
    fetchInfo()
    setTimeout(() => {
      setLoading(true);
    }, 1000);
  }, []);

  const fetchInfo = async () => {
    const urlInfo = `${API_URL}/api/users/info`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    await axios
      .get(urlInfo, config)
      .then((response) => {
        setUserInfo(response?.data?.result);
        if (CheckSubAdmin(response?.data?.result?.positionSubAdmin).length === 0 ||
          (CheckSubAdmin(response?.data?.result?.positionSubAdmin).length > 0 && 
          !CheckSubAdmin(response?.data?.result?.positionSubAdmin).includes(6) &&
          !CheckSubAdmin(response?.data?.result?.positionSubAdmin).includes(0))) 
        {
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const EvaluateMenu = [
    {
      icon: <i className="fa-solid fa-users" style={{paddingTop: "2px",paddingLeft: "0.1rem",paddingRight: "0.1rem",}} ></i>,
      name: "เจ้าหน้าที่",
      textLabel: <span className="ps-2" style={{whiteSpace: "nowrap"}}>เจ้าหน้าที่</span>,
      buttonSectionID: 0,
      path: "",
      activeClick: null,
    },
    {
      icon: <i className="fa-solid fa-arrow-up-9-1 px-1" style={{paddingTop: "2px"}}></i>,
      name: "ข้อมูลเลขที่ตำแหน่ง",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">ข้อมูลเลขที่ตำแหน่ง</span>,
      buttonSectionID: 7,
      path: "/?menu=positionNo",
      activeClick:"positionNo",
    },
    {
      icon: <i className="fa-solid fa-user-crown px-1" style={{paddingTop: "2px"}}></i>,
      name: "กำหนดข้อมูลผู้บังคับบัญชา",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">กำหนดข้อมูลผู้บังคับบัญชา</span>,
      buttonSectionID: 1,
      path: "/?menu=supervisor",
      activeClick:"supervisor",
    },
    {
      icon: <i className="fa-solid fa-person-military-to-person" style={{paddingLeft: "0.2rem",paddingRight: "0.2rem",paddingTop: "2px"}}></i>,
      name: "กำหนดการปฏิบัติราชการแทน",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">กำหนดการปฏิบัติราชการแทน</span>,
      buttonSectionID: 2,
      path: "/?menu=performing_official",
      activeClick:"performing_official",
    },
    {
      icon: <i className="fa-solid fa-business-time" style={{paddingLeft: "0.1rem",paddingRight: "0.1rem",paddingTop: "2px"}}></i>,
      name: "กำหนดการลงเวลาแบบกลุ่ม",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">กำหนดการลงเวลาแบบกลุ่ม</span>,
      buttonSectionID: 3,
      path: "/?menu=group_time_attendance",
      activeClick:"group_time_attendance",
    },
    {
      icon: <i className="fa-solid fa-house-person-return" style={{paddingLeft: "0.1rem",paddingRight: "0.1rem",paddingTop: "2px"}}></i>,
      name: "ลงเวลาเข้าออกงานแบบกลุ่ม",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">ลงเวลาเข้าออกงานแบบกลุ่ม</span>,
      buttonSectionID: 4,
      path: "/?menu=out_as_group",
      activeClick:"out_as_group",
    },
    {
      icon: <i className="fa-solid fa-money-simple-from-bracket" style={{paddingLeft: "0.1rem",paddingRight: "0.1rem",paddingTop: "2px"}}></i>,
      name: "นำเข้าไฟล์เงินเดือน",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">นำเข้าไฟล์เงินเดือน</span>,
      buttonSectionID: 5,
      path: "/?menu=salary_file",
      activeClick:"salary_file",
    },
    {
      icon: <i className="fa-solid fa-users-gear" style={{paddingLeft: "0.1rem",paddingRight: "0.1rem",paddingTop: "2px"}}></i>,
      name: "ตั้งค่าลำดับอนุมัติการลา",
      textLabel: <span style={{whiteSpace: "nowrap"}} className="ps-3">ตั้งค่าลำดับอนุมัติการลา</span>,
      buttonSectionID: 6,
      path: "/?menu=leave_approval_sequence",
      activeClick:"leave_approval_sequence",
    },
  ];

  return (
    <Fragment>
      {!loading ? (
        <LoadingPage />
      ) : filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 5 || Number(filterSubAdmin) === 6) ? (
        <div className="page-content">
          <FadeIn>
              <Row>
                <Col className="custom-menu">
                  {EvaluateMenu.map((i,idx)=>{
                    if (filterSubAdmin.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 5 ) && i?.buttonSectionID !== 4 && i?.buttonSectionID !== 5) {
                      return(
                      <Tooltip key={idx} title={i?.name}>
                        <button
                          className={
                            paramName === i?.activeClick
                              ? "rounded-pill btn btn-primary"
                              : "rounded-pill btn btn-outline-primary"
                          }
                          onClick={() => {
                            navigate(`/setdata${i?.path}`);
                          }}
                        >
                          <Row>
                            <Col className="d-flex justify-content-center">
                              {i?.icon}
                              {paramName === i?.activeClick && (
                                <FadeIn>
                                    {i?.textLabel}
                                </FadeIn>
                            )}
                            </Col>
                          </Row>
                        </button>
                      </Tooltip>
                      )
                    } 
                    // else if (i?.buttonSectionID === 4 && CheckPosition(userInfo?.position)[0] === 1) {
                    else if (i?.buttonSectionID === 4 && CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(0)) {
                      return(
                          <Tooltip key={idx} title={i?.name}>
                            <button
                              className={
                                paramName === i?.activeClick
                                  ? "rounded-pill btn btn-primary"
                                  : "rounded-pill btn btn-outline-primary"
                              }
                              onClick={() => {
                                navigate(`/setdata${i?.path}`);
                              }}
                            >
                              <Row>
                                <Col className="d-flex justify-content-center">
                                  {i?.icon}
                                  {paramName === i?.activeClick && (
                                    <FadeIn>
                                        {i?.textLabel}
                                    </FadeIn>
                                )}
                                </Col>
                              </Row>
                            </button>
                          </Tooltip>
                        )
                    }

                    else if (
                          i?.buttonSectionID === 5 
                          && 
                          // i?.buttonSectionID === 0 && 
                          CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
                          (CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(6) || CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(0))
                      ) {
                      return(
                          <Tooltip key={idx} title={i?.name}>
                            <button
                              className={
                                paramName === i?.activeClick
                                  ? "rounded-pill btn btn-primary"
                                  : "rounded-pill btn btn-outline-primary"
                              }
                              onClick={() => {
                                navigate(`/setdata${i?.path}`);
                              }}
                            >
                              <Row>
                                <Col className="d-flex justify-content-center">
                                  {i?.icon}
                                  {paramName === i?.activeClick && (
                                    <FadeIn>
                                        {i?.textLabel}
                                    </FadeIn>
                                )}
                                </Col>
                              </Row>
                            </button>
                          </Tooltip>
                        )
                    }
                  })}
                  {CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
                    !(CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(6)) &&
                      <Tooltip
                        title={
                          isButtonOn
                            ? "เปิดปิดการใช้งาน GPS (เปิด)"
                            : "เปิดปิดการใช้งาน GPS (ปิด)"
                        }
                      >
                        <button
                          className={
                            isButtonOn
                              ? "rounded-pill btn btn-success"
                              : "rounded-pill btn btn-danger"
                          }
                          color={isButtonOn ? "success" : "danger"}
                          onClick={()=>(setconfirmModal(true))}
                        >
                          <Row>
                            <Col md={2} lg={2}>
                              <i className="fa-solid fa-location-dot px-1"></i>
                            </Col>
                          </Row>
                        </button>
                      </Tooltip>}
                </Col>
              </Row>
            <Container fluid>
              {CheckSubAdmin(userInfo?.positionSubAdmin).length > 0 && 
                CheckSubAdmin(userInfo?.positionSubAdmin)?.includes(6) ?
                    <Breadcrumb
                      title="หน้าหลัก"
                      breadcrumbItem="นำเข้าไฟล์เงินเดือน"
                      isSubMenu={false}
                      path={`/setdata/?menu=salary_file`}
                    />
                  : <Breadcrumb
                      title="หน้าหลัก"
                      breadcrumbItem="กำหนดข้อมูล"
                      isSubMenu={true}
                      subMenuName={`${EvaluateMenu.find(x=> x.activeClick === paramName).name}`}
                      path={`/setdata${EvaluateMenu.find(x=> x.activeClick === paramName).path}`}
                    />
              }
              <Row>
                {paramName === null ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <ViewData userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "supervisor" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <ViewCommander userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "performing_official" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <AssignCommander userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "group_time_attendance" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <TimeCommander userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "salary_file" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <UploadSlipMoney userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "leave_approval_sequence" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <LeaveConfig userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "out_as_group" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <TimeEntryExitGroup userInfo={userInfo}/>
                  </Col>
                ) : (
                  ""
                )}

                {paramName === "positionNo" ? (
                  <Col md={12} lg={12} xl={12} xxl={12}>
                    <UserpositionNoDatatable/>
                  </Col>
                ) : (
                  ""
                )}
                
              </Row>
            </Container>
          </FadeIn>
        </div>
      ) : (
        <div className="page-content">
          <Container fluid>
            <div className="custom-menu">
              <Tooltip title="เจ้าหน้าที่">
                <button
                  className={
                    buttonSection === 0
                      ? "rounded-pill btn btn-primary"
                      : "rounded-pill btn btn-outline-primary"
                  }
                >
                    <Row>
                      <Col className="d-flex justify-content-center">
                        <i className="fa-solid fa-users" style={{paddingTop: "2px",paddingLeft: "0.1rem",paddingRight: "0.1rem",}} ></i>
                        {showTextID1 && (
                          <FadeIn>
                            <span
                              className="ps-2"
                              style={{whiteSpace: "nowrap"}}
                            >
                              เจ้าหน้าที่
                            </span>
                          </FadeIn>
                      )}
                      </Col>
                    </Row>
                </button>
              </Tooltip>
            </div>
            <Breadcrumb
              title="หน้าหลัก"
              breadcrumbItem="กำหนดข้อมูล"
              home={true}
            />
            <Row>
              {buttonSection === 0 ? (
                <Col md={12} lg={12} xl={12} xxl={12}>
                  <ViewDataUser userInfo={userInfo}/>
                </Col>
              ) : (
                ""
              )}
            </Row>
          </Container>
        </div>
      )}
      <ConfirmModal
        modal = {confirmModal}
        modalSize = "md"
        modalHeaderContent = {isButtonOn ? "คุณต้องการที่จะปิด GPS ใช่หรือไม่?" :"คุณต้องการที่จะเปิด GPS ใช่หรือไม่?"}
        onClickConfirmBtn={() => {
          toggleButton()
          setconfirmModal(false)
        }}
        onClickCancelBtn={() => {
          setconfirmModal(false)
        }}
      />
    </Fragment>
  );
}

export default SetData;
